import { render } from "./UserResetPassword.vue?vue&type=template&id=533e7e05&scoped=true"
import script from "./UserResetPassword.vue?vue&type=script&lang=js"
export * from "./UserResetPassword.vue?vue&type=script&lang=js"

import "./userresetpassword-responsive.css?vue&type=style&index=0&id=533e7e05&scoped=true&lang=css&external"
import "./UserResetPassword.vue?vue&type=style&index=1&id=533e7e05&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533e7e05"]])

export default __exports__